<template>
  <form @submit.prevent="submit">
    <Field
      hidden
      label="type"
      @input="$v.resource.type.$touch()"
      @handleChange="handleChange"
      v-model="resource.type"
      :error="typeError"/>

    <Field
      v-if="showSocialOptions"
      label="Social Platform"
      type="select"
      :options="socialNetworkOptions"
      @input="$v.resource.key.$touch()"
      @handleChange="handleChange"
      v-model="resource.key"
      :error="typeError"/>

    <Field
      :label="label"
      @input="$v.resource.value.$touch()"
      @handleChange="handleChange"
      v-model="resource.value"
      :error="valueError"/>

    <div class="btn-save">
      <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'ContactForm',

  mixins: [form],

  components: {
    Btn
  },

  props: {
    contactType: String,
    contactKey: String,
    isSocial: Boolean,
    showOptions: Boolean
  },

  computed: {
    ...errorMessages(['key', 'value', 'type']),

    label() {
      return this.isSocial ? 'Username' : this.contactKey
    },

    showSocialOptions() {
      return this.showOptions && this.isSocial
    },

    socialNetworkOptions() {
      return [
        {
          key: 'Facebook',
          value: 'facebook'
        },
        {
          key: 'Instagram',
          value: 'instagram'
        },
        {
          key: 'Google',
          value: 'google'
        },
        {
          key: 'Twitter',
          value: 'twitter'
        },
        {
          key: 'YouTube',
          value: 'youtube'
        },
        {
          key: 'Snapchat',
          value: 'snapchat'
        },
        {
          key: 'Pinterest',
          value: 'pinterest'
        },
        {
          key: 'LinkedIn',
          value: 'linkedin'
        }
      ]
    }
  },

  validations: {
    resource: {
      key: {required},
      value: {required},
      type: {required}
    }
  }
}
</script>
